import { render, staticRenderFns } from "./ProjectCase.vue?vue&type=template&id=622d1003&scoped=true"
import script from "./ProjectCase.vue?vue&type=script&lang=js"
export * from "./ProjectCase.vue?vue&type=script&lang=js"
import style0 from "./ProjectCase.vue?vue&type=style&index=0&id=622d1003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d1003",
  null
  
)

export default component.exports